import Slider from "react-slick";
import StaggeredListItem from "./StaggeredListItem";
import styles from './styles.module.css';
import { css } from "@emotion/react";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

interface IStaggeredListProps {
    items: IStaggeredListItem[],
    onItemClick?: (item)=>void,
    backgroundType: 'icon' | 'cover',
    border?:boolean,
    type?: string,
}

export interface IStaggeredListItem {
    title: string,
    image?: string,
    background?: string,
    aspectRatio?:number,
    extraData?: any,
    Title?:string,
    Image?:string,
    ExtraData?: any,
    id?: string | number,
    widgetImage?: string,
    listTypeName?: string
    aiTaskDisable?: boolean
}

export default function StaggeredList({items, onItemClick=()=>{},backgroundType, border=true, type}:IStaggeredListProps) {


    const sliderRef = useRef<HTMLDivElement>();

    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const calcArrows = () => {
        const sliderWidth = sliderRef.current?.scrollWidth;
        const slidesWidth = sliderRef.current?.clientWidth;
        const scrollXOffset = sliderRef.current?.scrollLeft;
        setShowRightArrow(sliderWidth > scrollXOffset + slidesWidth + 10);
        setShowLeftArrow(!!scrollXOffset);
    }

    useLayoutEffect(()=>{
        if(!sliderRef.current) return;
        const observer = new ResizeObserver(calcArrows);
        sliderRef.current.addEventListener("scroll",calcArrows);
        observer.observe(sliderRef.current);
        return () => {
            sliderRef.current?.removeEventListener("scroll",calcArrows);
            observer.disconnect();
        }
    },[])


    // FUNCTION THAT CHECK IF RATIO IS IN STRING TYPE, RETURN CORRECT RATIO AFTER CONVERSION
    // IF NUMBER TYPE, ISMPLY RETURN ITSELF
    const getAspectRatio = (aspectRatio:string) => {
        if(typeof aspectRatio == "number") return aspectRatio
        if(!aspectRatio?.includes("/")) return parseInt(aspectRatio)
        const parts = aspectRatio?.split("/");
        const numerator = parseInt(parts[0]);
        const denominator = parseInt(parts[1]);

        // Check if both parts are valid numbers
        if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
            // Calculate the ratio as a floating-point number
            const ratio = numerator / denominator;
            console.log(ratio); // Output: 1.7777777777777777
            return ratio
        } else {
            console.log("Invalid aspect ratio format");
        }
    }

    return <div css={emotionStyles.container}>
        {showLeftArrow && <div css={css`
            box-shadow: 0px 0px 16px 0px #0000003D;
            width: 40px;
            height: 40px;
            padding: 8px, 8px, 8px, 8px;
            border-radius: 1000px;
            background-color:white;
        `} onClick={()=>{
                sliderRef.current.scrollBy({
                    left: -600,
                    behavior: 'smooth'
                })
            }} style={{left:0, position:'absolute', top:'50%', transform:"translate(-50%, -50%) rotate(-180deg)", zIndex:6, cursor:"pointer", display:'flex', justifyContent:'center', alignItems:"center"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 4L16 12L8 20" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>}
        <div ref={sliderRef} css={css`
            ::-webkit-scrollbar: {
                display: 'none',
            } 
        `} style={{width:'100%',overflowX:'scroll', display:'flex', gap:"30px", alignItems:'flex-end', padding: '11px 0' }}> 
            {
                items?.map((item)=>{
                    const splittedRatio = getAspectRatio(item?.aspectRatio?.toString())
                    return (
                        <div onClick={()=>onItemClick(item)}>
                            <StaggeredListItem 
                                title={item.title || item?.Title} 
                                image={item?.image || item.Image} 
                                mode={backgroundType} 
                                color={item.background}
                                border={border} 
                                aspectRatio={splittedRatio}
                            />
                        </div>
                    )}
                )
            }
        </div>
        {showRightArrow && <div css={css`
            box-shadow: 0px 0px 16px 0px #0000003D;
            width: 40px;
            height: 40px;
            padding: 8px, 8px, 8px, 8px;
            border-radius: 1000px;
            background-color:white;
        `} onClick={()=>{
                sliderRef.current.scrollBy({
                    left: 600,
                    behavior: 'smooth'
                })
            }} style={{right:0, position:'absolute', top:'50%', transform:"translate(25%, -50%)", zIndex:1, cursor:'pointer', display:'flex', justifyContent:'center', alignItems:"center"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M8 4L16 12L8 20" stroke="#262626" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>}
    </div>
}

const emotionStyles = {
    container: css`
    position:relative;
    & .slick-track {
        display: inline-flex;
        align-items: flex-start;
        gap: 16px;
    }
`
}